import { deepClone, getTypeVersionKey, StateJson } from '@easytwin/runtime';
import { create } from 'zustand';

export type ClipBoardType = {
  data: StateJson;
  typeVersion: string;
} | null;

interface CopyStateStore {
  clipboard: ClipBoardType | undefined;
  setClipboard: (data: StateJson, type: string, version: string) => void;
}

export const useCopyStateStore = create<CopyStateStore>((set, get) => ({
  clipboard: undefined,
  setClipboard: (data, type, version) => {
    set({
      clipboard: { data: deepClone(data), typeVersion: getTypeVersionKey(type, version) },
    });
  },
}));
